module.exports = __webpack_public_path__ + "static/media/notificationRead.58d7fbdc.svg";